import * as React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Grid, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { theme } from '../../theme/theme';

const ConfirmationDialog = (props) => {
    const handleOk = () => {
        if (props.onConfirmed) {
            props.onConfirmed()
        }

        if (props.onClose) {
            props.onClose()
        }
    }

    return (
        <Dialog 
            open={props.open}
            onClose={props.onClose}
            maxWidth={'md'}
            PaperProps={{
                style: {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText
                },
            }}
        >
            <DialogTitle>
                <Grid container direction='row' alignItems={'center'} justifyContent={'space-between'}>
                    <Grid item>
                        <Typography fontWeight={700}>
                            {props.title}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <IconButton onClick={props.onClose}>
                            <CloseIcon htmlColor='white' />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Typography whiteSpace={'pre'}>
                    {props.message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-between" }}>
                <Button autoFocus onClick={props.onClose} sx={{ color: theme.palette.tertiary.contrastText, backgroundColor: theme.palette.dashboard.bulkCancel }}>Cancel</Button>
                <Button onClick={handleOk} sx={{ color: theme.palette.tertiary.contrastText, backgroundColor: theme.palette.tertiary.main }}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}
export default ConfirmationDialog;